import * as React from 'react';
import * as Response from 'api/responses';
import * as Transform from 'api/transform';
import { useAuthentication, useFetch, useNotifications } from 'hooks';
import { GetPropertiesDataResponsePayload } from 'store/types/user-management/properties.types';
import { Type } from 'constants/config';

const useProperties = (skipOnStart: boolean = false) => {
  const { type, token } = useAuthentication();
  const [pagination, setPagination] = React.useState({
    page: 1,
    size: 5,
    supplier: true,
    name: '',
    unit__isnull: true,
  });
  const { showNotification } = useNotifications();

  const onFailure = React.useCallback(() => {
    showNotification({
      key: 'properties/getPropertiesDataRejected',
      message:
        'We had a problem fetching your properties, please try again later',
      severity: 'error',
    });
  }, [showNotification]);

  const { data: properties, isLoading, callFetch } = useFetch<
    GetPropertiesDataResponsePayload,
    Response.Properties
  >({
    initialUrl: `/api/properties/`,
    skipOnStart,
    config: {
      params:
        type === Type.SELLER
          ? pagination
          : {
              page: pagination.page,
              size: pagination.size,
              name: pagination.name,
              unit__isnull: true,
            },
    },
    onFailure,
    transform: Transform.Properties,
  });
  React.useEffect(() => {
    if (token)
      callFetch({
        params:
          type === Type.SELLER
            ? pagination
            : {
                page: pagination.page,
                size: pagination.size,
                name: pagination.name,
                unit__isnull: true,
              },
      });
  }, [pagination, type, callFetch, token]);
  const propertyList = React.useMemo(() => {
    if (properties && properties?.results.length > 0 && type === Type.CLIENT) {
      const filterProperty = properties?.results?.filter(
        a => a.status !== 'waiting'
      );
      properties.results = filterProperty;
    }
    return properties;
  }, [properties, type]);
  return {
    properties: propertyList,
    isLoading,
    callFetch,
    pagination,
    setPagination,
  };
};

export default useProperties;
